const directionsSigs = [
  "Inject 0.10ml (10 units) subq once weekly. (0.25mg)",
  "Inject 0.20ml (20 units) subq once weekly. (0.5mg)",
  "Inject 0.30ml (30 units) subq once weekly. (0.75mg)",
  "Inject 0.40ml (40 units) subq once weekly. (1.0mg)",
  "Inject 0.50ml (50 units) subq once weekly. (1.25mg)",
  "Inject 0.60ml (60 units) subq once weekly. (1.5mg)",
  "Inject 0.70ml (70 units) subq once weekly. (1.75mg)",
  "Inject 0.80ml (80 units) subq once weekly. (2.0mg)",
  "Inject 0.90ml (90 units) subq once weekly. (2.25mg)",
  "Inject 1.00ml (100 units) subq once weekly. (2.5mg)",
  "Inject 0.10ml (10 units) subq once weekly. (2.5mg)",
  "Inject 0.15ml (15 units) subq once weekly. (3.75mg)",
  "Inject 0.20ml (20 units) subq once weekly. (5.0mg)",
  "Inject 0.25ml (25 units) subq once weekly. (6.25mg)",
  "Inject 0.30ml (30 units) subq once weekly. (7.5mg)",
  "Inject 0.35ml (35 units) subq once weekly. (8.75mg)",
  "Inject 0.40ml (40 units) subq once weekly. (10.0mg)",
  "Inject 0.45ml (45 units) subq once weekly. (11.25mg)",
  "Inject 0.50ml (50 units) subq once weekly. (12.5mg)",
  "Inject 0.60ml (60 units) subq once weekly. (15.0mg)",
  "Inject 0.05ml (5 units) subq once weekly. (0.125mg)",
  "Inject 0.07ml (7 units) subq once weekly. (0.175mg)",
  "Inject 0.08ml (8 units) subq once weekly. (0.2mg)",
  "Inject 0.12ml (12 units) subq once weekly. (0.3mg)",
  "Inject 0.14ml (14 units) subq once weekly. (0.35mg)",
  "Inject 0.16ml (16 units) subq once weekly. (0.4mg)",
  "Inject 0.18ml (18 units) subq once weekly. (0.45mg)",
  "Inject 0.22ml (22 units) subq once weekly. (0.55mg)",
  "Inject 0.24ml (24 units) subq once weekly. (0.6mg)",
  "Inject 0.26ml (26 units) subq once weekly. (0.65mg)",
  "Inject 0.28ml (28 units) subq once weekly. (0.7mg)",
  "Inject 0.32ml (32 units) subq once weekly. (0.8mg)",
  "Inject 0.34ml (34 units) subq once weekly. (0.85mg)",
  "Inject 0.36ml (36 units) subq once weekly. (0.9mg)",
  "Inject 0.38ml (38 units) subq once weekly. (0.95mg)",
  "Inject 0.42ml (42 units) subq once weekly. (1.05mg)",
  "Inject 0.44ml (44 units) subq once weekly. (1.1mg)",
  "Inject 0.46ml (46 units) subq once weekly. (1.15mg)",
  "Inject 0.48ml (48 units) subq once weekly. (1.2mg)",
  "Inject 0.52ml (52 units) subq once weekly. (1.3mg)",
  "Inject 0.54ml (54 units) subq once weekly. (1.35mg)",
  "Inject 0.55ml (55 units) subq once weekly. (1.375mg)",
  "Inject 0.56ml (56 units) subq once weekly. (1.4mg)",
  "Inject 0.58ml (58 units) subq once weekly. (1.45mg)",
  "Inject 0.62ml (62 units) subq once weekly. (1.55mg)",
  "Inject 0.64ml (64 units) subq once weekly. (1.6mg)",
  "Inject 0.65ml (65 units) subq once weekly. (1.625mg)",
  "Inject 0.66ml (66 units) subq once weekly. (1.65mg)",
  "Inject 0.68ml (68 units) subq once weekly. (1.7mg)",
  "Inject 0.72ml (72 units) subq once weekly. (1.8mg)",
  "Inject 0.74ml (74 units) subq once weekly. (1.85mg)",
  "Inject 0.75ml (75 units) subq once weekly. (1.875mg)",
  "Inject 0.76ml (76 units) subq once weekly. (1.9mg)",
  "Inject 0.78ml (78 units) subq once weekly. (1.95mg)",
  "Inject 0.82ml (82 units) subq once weekly. (2.05mg)",
  "Inject 0.84ml (84 units) subq once weekly. (2.1mg)",
  "Inject 0.85ml (85 units) subq once weekly. (2.125mg)",
  "Inject 0.86ml (86 units) subq once weekly. (2.15mg)",
  "Inject 0.88ml (88 units) subq once weekly. (2.2mg)",
  "Inject 0.92ml (92 units) subq once weekly. (2.3mg)",
  "Inject 0.94ml (94 units) subq once weekly. (2.35mg)",
  "Inject 0.95ml (95 units) subq once weekly. (2.375mg)",
  "Inject 0.96ml (96 units) subq once weekly. (2.4mg)",
  "Inject 0.98ml (98 units) subq once weekly. (2.45mg)",
  "Inject 0.02ml (2 units) subq once weekly. (0.2mg)",
  "Inject 0.03ml (3 units) subq once weekly. (0.3mg)",
  "Inject 0.04ml (4 units) subq once weekly. (0.4mg)",
  "Inject 0.05ml (5 units) subq once weekly. (0.5mg)",
  "Inject 0.06ml (6 units) subq once weekly. (0.6mg)",
  "Inject 0.07ml (7 units) subq once weekly. (0.7mg)",
  "Inject 0.08ml (8 units) subq once weekly. (0.8mg)",
  "Inject 0.09ml (9 units) subq once weekly. (0.9mg)",
  "Inject 0.11ml (11 units) subq once weekly. (1.1mg)",
  "Inject 0.12ml (12 units) subq once weekly. (1.2mg)",
  "Inject 0.13ml (13 units) subq once weekly. (1.3mg)",
  "Inject 0.14ml (14 units) subq once weekly. (1.4mg)",
  "Inject 0.15ml (15 units) subq once weekly. (1.5mg)",
  "Inject 0.16ml (16 units) subq once weekly. (1.6mg)",
  "Inject 0.17ml (17 units) subq once weekly. (1.7mg)",
  "Inject 0.18ml (18 units) subq once weekly. (1.8mg)",
  "Inject 0.19ml (19 units) subq once weekly. (1.9mg)",
  "Inject 0.21ml (21 units) subq once weekly. (2.1mg)",
  "Inject 0.22ml (22 units) subq once weekly. (2.2mg)",
  "Inject 0.23ml (23 units) subq once weekly. (2.3mg)",
  "Inject 0.24ml (24 units) subq once weekly. (2.4mg)",
  "Inject 0.25ml (25 units) subq once weekly. (2.5mg)",
  "Inject 0.30ml (30 units) subq once weekly. (3.0mg)",
  "Inject 0.35ml (35 units) subq once weekly. (3.5mg)",
  "Inject 0.40ml (40 units) subq once weekly. (4.0mg)",
  "Inject 0.45ml (45 units) subq once weekly. (4.5mg)",
  "Inject 0.50ml (50 units) subq once weekly. (5.0mg)",
  "Inject 0.55ml (55 units) subq once weekly. (5.5mg)",
  "Inject 0.60ml (60 units) subq once weekly. (6.0mg)",
  "Inject 0.65ml (65 units) subq once weekly. (6.5mg)",
  "Inject 0.70ml (70 units) subq once weekly. (7.0mg)",
  "Inject 0.75ml (75 units) subq once weekly. (7.5mg)",
  "Inject 0.80ml (80 units) subq once weekly. (8.0mg)",
  "Inject 0.85ml (85 units) subq once weekly. (8.5mg)",
  "Inject 0.90ml (90 units) subq once weekly. (9.0mg)",
  "Inject 1.00ml (100 units) subq once weekly. (10.0mg)",
  "Inject 0.18ml (18 units) subq once weekly. (3mg)",
  "Inject 0.35ml (35 units) subq once weekly. (6mg)",
  "Inject 0.5ml (50 units) subq once weekly. (8.5mg)",
  "Inject 0.68ml (68 units) subq once weekly. (11.5mg)",
  "Inject 0.85ml (85 units) subq once weekly. (14.5mg)",
  "Inject 1ml (100 units) subq once weekly. (17mg)",
  "Inject 0.25ml (25 units) subq once weekly. (0.25mg)",
  "Inject 0.5ml (50 units) subq once weekly. (0.5mg)",
  "Inject 1ml (100 units) subq once weekly. (1mg)",
  "Inject 0.7ml (70 units) subq once weekly. (1.75mg)",
  "Inject 1ml (100 units) subq once weekly. (2.5mg)"
];

export default directionsSigs